module.exports = __webpack_public_path__ + "static/img/company_history2016.7bea1d8b.jpg";